import { render, staticRenderFns } from "./cart_item.vue?vue&type=template&id=1f9fb03e"
import script from "./cart_item.vue?vue&type=script&lang=js"
export * from "./cart_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Availability: require('/root/containers/hermes_eshop/components/core/availability.vue').default})
